import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import AddIcon from "@material-ui/icons/Add"
import ABNPriceEnvRisk from "./ABNPriceEnvRisk";
import ABNPriceLocationRisk from "./ABNPriceLocationRisk";

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePriceResponseABN extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  ABN_price_id: "",
                  ABN_price_buildpercent: "",
                  ABN_price_furniturepercent: "",
                  ABN_price_discount: "",
                  selectedCompany: "",
                  ABN_price_deactive: "0",
                  company_logo_url: "",
                  orderBy: "ABN_price_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newPriceABN: true,
                  optionCompany: [],
                  optionKind: [],
                  optionTypeofcons: [],
                  openDialog: false,
                  ABNPriceEnvRisks: [],
                  ABNPriceLocationRisks: [],
                  ABNBuildinglife: [],
                  ABN_price_env_risk_rate: "",
                  ABN_price_location_risk_death_rate: "",
                  ABN_price_location_risk_cure_rate: "",
                  ABN_price_buildinglife_percent: "",
                  selectedABNEnvRisk: "",
                  selectedABNLocationRisk: "",
                  selectedABNBuildinglife: "",
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }


      handleChangeDisc = (event) => {
            this.setState({ ABN_price_discount: event })
      }


      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany }, () => {
                  this.filterPriceABN()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ ABN_price_deactive: "0" })
            } else {
                  this.setState({ ABN_price_deactive: "1" })
            }
      }

      handleABNEnvRisk = (selectedABNEnvRisk) => {
            this.setState({ selectedABNEnvRisk: selectedABNEnvRisk })
      }
      handleABNLocationRisk = (selectedABNLocationRisk) => {
            this.setState({ selectedABNLocationRisk: selectedABNLocationRisk })
      }

      handleABNBuildinglife = (selectedABNBuildinglife) => {
            this.setState({ selectedABNBuildinglife: selectedABNBuildinglife })
      }

      handleChangeEnvRiskRate = (event) => {
            this.setState({ ABN_price_env_risk_rate: event })
      }
      handleChangeLocationRiskDeathRate = (event) => {
            this.setState({ ABN_price_location_risk_death_rate: event })
      }
      handleChangeLocationRiskCureRate = (event) => {
            this.setState({ ABN_price_location_risk_cure_rate: event })
      }

      handleChangeABNBuildinglife = (event) => {
            this.setState({ ABN_price_buildinglife_percent: event })
      }

      handleSelectRows = (row2) => {
            this.getpriceEnvRisk(row2.ABN_price_id)
            this.getpriceLocationRisk(row2.ABN_price_id)
            // this.getABNBuildinglife(row2.ABN_price_id)
            this.setState(
                {
                      ABN_price_id: row2.ABN_price_id,
                      ABN_price_discount: row2.ABN_price_discount,
                      ABN_price_deactive: row2.ABN_price_deactive,
                      company_logo_url: row2.company_logo_url,
                      newPriceABN: false,
                },
                () => {}
            )
      }

      newPriceABN = (event) => {
            this.setState({
                  ABN_price_id: "",
                  ABN_price_discount: "",
                  selectedCompany: "",
                  ABN_price_deactive: "0",
                  company_logo_url: "",
                  newPriceABN: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getoptionCompany()
                                    self.getoptionEnvRisk()
                                    self.getoptionLocationRisk()

                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deleteABNPrice = () => {
            const { ABN_price_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getPriceABN()
                              self.newPriceABN()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_ABN_price")
            fd.append("ABN_price_id", ABN_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/ABN`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getPriceABN() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterPriceABN()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_ABN_price")

            xhttp.open("POST", `${constants.BASE_URL}/ABN`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getpriceEnvRisk(ABN_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ ABNPriceEnvRisks: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ ABNPriceEnvRisks: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_env")
                  fd.append("ABN_price_id", ABN_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/ABN`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }
      getpriceLocationRisk(ABN_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ ABNPriceLocationRisks: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ ABNPriceLocationRisks: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_location")
                  fd.append("ABN_price_id", ABN_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/ABN`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }



      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldcompany_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                                    self.getPriceABN()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldcompany")
            fd.append("fieldinsurance", "ABN")
            xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
            xhttp.send(fd)
      }
      getoptionEnvRisk = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].ABN_env_risk_id,
                                          label: arr.data[k].ABN_env_risk_name
                                    })
                              }
                              self.setState({ optionABNEnvRisk: Company, selectedABNEnvRisk: Company[0] }, () => {

                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_env_risk")
            xhttp.open("POST", `${constants.BASE_URL}/ABN`)
            xhttp.send(fd)
      }
      getoptionLocationRisk = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].ABN_location_risk_id,
                                          label: arr.data[k].ABN_location_risk_name
                                    })
                              }
                              self.setState({ optionABNLocationRisk: Company, selectedABNLocationRisk: Company[0] }, () => {

                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_location_risk")
            xhttp.open("POST", `${constants.BASE_URL}/ABN`)
            xhttp.send(fd)
      }


      saveNewPriceABN = () => {
            const {
                  ABN_price_buildpercent,
                  ABN_price_furniturepercent,
                  ABN_price_discount,
                  selectedCompany,
                  selectedKind,
                  ABN_price_deactive,
            } = this.state
            if (
                selectedCompany != ""

            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceABN()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_ABN_price")
                  fd.append("ABN_price_discount", ABN_price_discount)
                  fd.append("ABN_price_fieldcompany_id", selectedCompany.value)
                  fd.append("ABN_price_deactive", ABN_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/ABN`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceABNEnvRisk = () => {
            const { ABN_price_id, selectedABNEnvRisk, ABN_price_env_risk_rate } = this.state
            if (selectedABNEnvRisk != "" && ABN_price_env_risk_rate != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ ABN_price_env_risk_rate: "", selectedABNEnvRisk: "" })
                                    self.getpriceEnvRisk(ABN_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_env")
                  fd.append("ABN_price_env_risk_ABN_price_id", ABN_price_id)
                  fd.append("ABN_price_env_risk_rate", ABN_price_env_risk_rate)
                  fd.append("ABN_price_env_risk_env_risk_id", selectedABNEnvRisk.value)

                  xhttp.open("POST", `${constants.BASE_URL}/ABN`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }
      saveNewPriceABNLocationRisk = () => {
            const { ABN_price_id, selectedABNLocationRisk, ABN_price_location_risk_death_rate, ABN_price_location_risk_cure_rate } = this.state
            if (selectedABNLocationRisk != "" && ABN_price_location_risk_death_rate != "", ABN_price_location_risk_cure_rate != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ ABN_price_location_risk_death_rate: "", selectedABNLocationRisk: "", ABN_price_location_risk_cure_rate: "" })
                                    self.getpriceLocationRisk(ABN_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_location")
                  fd.append("ABN_price_location_risk_ABN_price_id", ABN_price_id)
                  fd.append("ABN_price_location_risk_death_rate", ABN_price_location_risk_death_rate)
                  fd.append("ABN_price_location_risk_cure_rate", ABN_price_location_risk_cure_rate)
                  fd.append("ABN_price_location_risk_location_risk_id", selectedABNLocationRisk.value)

                  xhttp.open("POST", `${constants.BASE_URL}/ABN`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }


      modifyPriceResponseABN = () => {
            const {
                  ABN_price_id,
                  ABN_price_discount,
                  selectedCompany,
                  ABN_price_deactive,
            } = this.state
            if (
                selectedCompany != "" &&
                ABN_price_discount != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceABN()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_ABN_price")
                  fd.append("ABN_price_id", ABN_price_id)
                  fd.append("ABN_price_discount", ABN_price_discount)

                  fd.append("ABN_price_deactive", ABN_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/ABN`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                i,
                j,
                temp,
                a,
                b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterPriceABN = () => {
            const { selectedCompany, selectedKind, requestinfos } = this.state
            var temparray = requestinfos,
                temparray2 = [],
                i
            for (i = 0; i < temparray.length; i++) {
                  console.log(selectedCompany)
                  console.log(temparray[i].ABN_price_fieldcompany_id)
                  if (
                      (selectedCompany.value === 0 || temparray[i].ABN_price_fieldcompany_id === selectedCompany.value)

                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  ABN_price_env_risk_rate,
                  ABN_price_location_risk_death_rate,
                  ABN_price_location_risk_cure_rate,
                  ABN_price_buildinglife_percent,
                  selectedABNEnvRisk,
                  selectedABNLocationRisk,
                  selectedABNBuildinglife,
                  optionCompany,
                  optionABNEnvRisk,
                  optionABNLocationRisk,
                  optionABNBuildinglife,
                  optionKind,
                  optionTypeofcons,
                  ABNPriceEnvRisks,
                  ABNPriceLocationRisks,
                  ABNBuildinglife,
                  snackMode,
                  snackstr,
                  showSnack,
                  newPriceABN,
                  ABN_price_id,
                  ABN_price_buildpercent,
                  ABN_price_furniturepercent,
                  ABN_price_discount,
                  company_logo_url,
                  selectedCompany,
                  selectedKind,
                  ABN_price_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                      <div className={classes.paperrtl} dir="ltr">
                            <Snackbar
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                onClose={this.handleClickcloseTasckBar}
                                open={showSnack}
                                autoHideDuration={10000}
                            >
                                  <Alert severity={snackMode}>{snackstr}</Alert>
                            </Snackbar>
                            <Grid container spacing={3}>
                                  <Grid item xs={12}>
                                        <Container component="main" maxWidth="lg">
                                              <Paper elevation={4} className={classes.root}>
                                                    <Grid container spacing={3}>
                                                          <Grid item xs={6}>
                                                                <Typography align="center" variant="h7">
                                                                      {"شماره قیمت بیمه سازندگان ابنیه: " + ABN_price_id}
                                                                </Typography>
                                                          </Grid>
                                                          <Grid item xs={6}></Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">شرکت بیمه</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"شرکت بیمه"}
                                                                          value={selectedCompany}
                                                                          onChange={this.handleCompany}
                                                                          options={optionCompany}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <img alt="" className={classes.large} src={this.state.selectedCompany.logo} />
                                                                </div>
                                                          </Grid>

                                                       
                                                          <Grid item xs={4}>
                                                                <FloatingLabelInput
                                                                    type="percent"
                                                                    placeholder="تخفیف"
                                                                    handleInputt={this.handleChangeDisc}
                                                                    value={ABN_price_discount}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={4}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <FormControlLabel
                                                                          control={
                                                                                <Switch
                                                                                    checked={ABN_price_deactive === "0" ? true : false}
                                                                                    onChange={this.handleChangeDeactive}
                                                                                    name="gilad"
                                                                                />
                                                                          }
                                                                          label=" وضعیت قیمت شرکت بیمه"
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                {newPriceABN ? (
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        onClick={this.saveNewPriceABN}
                                                                    >
                                                                          {"ثبت قیمت بیمه سازندگان ابنیه جدید "}
                                                                    </Button>
                                                                ) : (
                                                                    <div style={{ width: "100%", textAlign: "right" }}>
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.newPriceABN}
                                                                          >
                                                                                {"قیمت بیمه سازندگان ابنیه جدید "}
                                                                          </Button>
                                                                          {"          "}
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.modifyPriceResponseABN}
                                                                          >
                                                                                {"ثبت تغییرات"}
                                                                          </Button>
                                                                          {"          "}
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.handleClickOpen()
                                                                              }}
                                                                          >
                                                                                {" حذف قیمت بیمه سازندگان ابنیه"}
                                                                          </Button>
                                                                    </div>
                                                                )}
                                                          </Grid>

                                                          {newPriceABN ? null : (
                                                              <Grid item xs={12}>
                                                                    <Divider />
                                                              </Grid>
                                                          )}
                                                    </Grid>
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                        <Container>
                                              <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                    {newPriceABN ? null : (
                                                        <Grid item xs={12}>
                                                              {ABNPriceEnvRisks.map((ABNPriceEnvRisks, index) => (
                                                                  <ABNPriceEnvRisk
                                                                      ABNPriceEnvRisk={ABNPriceEnvRisks}
                                                                      props={this.props}
                                                                      key={index}
                                                                  />
                                                              ))}
                                                        </Grid>
                                                    )}
                                              </Paper>

                                              <Paper className={classes.root}>
                                                    {newPriceABN ? null : (
                                                        <Grid item xs={12}>
                                                              <Grid container spacing={3}>
                                                                    <Grid item xs={5}>
                                                                          <div>
                                                                                <label className="on">درجه خطر مورد بیمه</label>
                                                                                <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"درجه خطر مورد بیمه"}
                                                                                    value={selectedABNEnvRisk}
                                                                                    onChange={this.handleABNEnvRisk}
                                                                                    options={optionABNEnvRisk}
                                                                                />
                                                                          </div>
                                                                    </Grid>

                                                                    <Grid item item xs={4}>
                                                                          <FloatingLabelInput
                                                                              type="percent"
                                                                              placeholder="درصد نرخ انتخابی"
                                                                              handleInputt={this.handleChangeEnvRiskRate}
                                                                              value={ABN_price_env_risk_rate}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item item xs={3}>
                                                                          <div style={{ width: "100%", textAlign: "left" }}>
                                                                                <Fab
                                                                                    className={classes.small}
                                                                                    color="primary"
                                                                                    aria-label="add"
                                                                                    onClick={this.saveNewPriceABNEnvRisk}
                                                                                >
                                                                                      <AddIcon />
                                                                                </Fab>
                                                                          </div>
                                                                    </Grid>
                                                              </Grid>
                                                        </Grid>
                                                    )}
                                              </Paper>
                                        </Container>
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                        <Container>
                                              <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                    {newPriceABN ? null : (
                                                        <Grid item xs={12}>
                                                              {ABNPriceLocationRisks.map((ABNPriceLocationRisks, index) => (
                                                                  <ABNPriceLocationRisk
                                                                      ABNPriceLocationRisk={ABNPriceLocationRisks}
                                                                      props={this.props}
                                                                      key={index}
                                                                  />
                                                              ))}
                                                        </Grid>
                                                    )}
                                              </Paper>

                                              <Paper className={classes.root}>
                                                    {newPriceABN ? null : (
                                                        <Grid item xs={12}>
                                                              <Grid container spacing={3}>
                                                                    <Grid item xs={4}>
                                                                          <div>
                                                                                <label className="on">ریسک موقعیت مکانی</label>
                                                                                <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"ریسک موقعیت مکانی"}
                                                                                    value={selectedABNLocationRisk}
                                                                                    onChange={this.handleABNLocationRisk}
                                                                                    options={optionABNLocationRisk}
                                                                                />
                                                                          </div>
                                                                    </Grid>

                                                                    <Grid item xs={3}>
                                                                          <FloatingLabelInput
                                                                              type="percent"
                                                                              placeholder="درصد نرخ فوت"
                                                                              handleInputt={this.handleChangeLocationRiskDeathRate}
                                                                              value={ABN_price_location_risk_death_rate}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item xs={3}>
                                                                          <FloatingLabelInput
                                                                              type="percent"
                                                                              placeholder="درصد نرخ پزشکی"
                                                                              handleInputt={this.handleChangeLocationRiskCureRate}
                                                                              value={ABN_price_location_risk_cure_rate}
                                                                          />
                                                                    </Grid>

                                                                    <Grid item item xs={2}>
                                                                          <div style={{ width: "100%", textAlign: "left" }}>
                                                                                <Fab
                                                                                    className={classes.small}
                                                                                    color="primary"
                                                                                    aria-label="add"
                                                                                    onClick={this.saveNewPriceABNLocationRisk}
                                                                                >
                                                                                      <AddIcon />
                                                                                </Fab>
                                                                          </div>
                                                                    </Grid>
                                                              </Grid>
                                                        </Grid>
                                                    )}
                                              </Paper>
                                        </Container>
                                  </Grid>



                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper className={classes.root}>
                                                    <TableContainer dir="rtl">
                                                          <Table aria-label="sticky table">
                                                                <TableHead>
                                                                      <TableRow>
                                                                            <TableCell
                                                                                key={"ABN_price_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                                sortDirection={orderBy === "ABN_price_id" ? order : false}
                                                                            >
                                                                                  {" آی دی تخفیف"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "ABN_price_id"}
                                                                                      direction={orderBy === "ABN_price_id" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("ABN_price_id")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"company_name"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"شرکت بیمه  "}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "company_name"}
                                                                                      direction={orderBy === "company_name" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("company_name")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                            <TableCell
                                                                                key={"ABN_price_kind_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نوع ملک"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "ABN_price_kind_id"}
                                                                                      direction={
                                                                                            orderBy === "ABN_price_kind_id" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("ABN_price_kind_id")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"ABN_price_typeofcons_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نوع ساخت"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "ABN_price_typeofcons_id"}
                                                                                      direction={
                                                                                            orderBy === "ABN_price_typeofcons_id"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("ABN_price_typeofcons_id")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"ABN_price_buildpercent"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نرخ حق بیمه سازه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "ABN_price_buildpercent"}
                                                                                      direction={
                                                                                            orderBy === "ABN_price_buildpercent"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("ABN_price_buildpercent")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"ABN_price_furniturepercent"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نرخ حق بیمه اثاثیه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "ABN_price_furniturepercent"}
                                                                                      direction={
                                                                                            orderBy === "ABN_price_furniturepercent"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "ABN_price_furniturepercent"
                                                                                            )
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"ABN_price_discount"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"تخفیف"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "ABN_price_discount"}
                                                                                      direction={
                                                                                            orderBy === "ABN_price_discount" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("ABN_price_discount")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"ABN_price_deactive"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                            >
                                                                                  {"وضعیت قیمت بیمه سازندگان ابنیه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "ABN_price_deactive"}
                                                                                      direction={
                                                                                            orderBy === "ABN_price_deactive" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("ABN_price_deactive")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                      </TableRow>
                                                                </TableHead>

                                                                <TableBody>
                                                                      {agentInfofilter
                                                                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                          .map((row) => {
                                                                                return (
                                                                                    <TableRow
                                                                                        hover
                                                                                        role="checkbox"
                                                                                        tabIndex={-1}
                                                                                        key={row["ABN_price_id"]}
                                                                                        value={row}
                                                                                        onClick={() => {
                                                                                              this.handleSelectRows(row)
                                                                                        }}
                                                                                    >
                                                                                          <TableCell key={"ABN_price_id"} align={"center"}>
                                                                                                {row["ABN_price_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"company_name"} align={"center"}>
                                                                                                {row["company_name"]}
                                                                                                <img
                                                                                                    className={classes.small}
                                                                                                    alt="Remy Sharp"
                                                                                                    src={row["company_logo_url"]}
                                                                                                />
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"ABN_price_kind_id"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["ABN_kind_name"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"ABN_price_typeofcons_id"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["ABN_typeofcons_name"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"ABN_price_buildpercent"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["ABN_price_buildpercent"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"ABN_price_furniturepercent"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["ABN_price_furniturepercent"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"ABN_price_discount"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["ABN_price_discount"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"ABN_price_deactive"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["ABN_price_deactive"] === "1" ||
                                                                                                row["ABN_price_deactive"] === 1 ? (
                                                                                                    <Fab variant="extended">
                                                                                                          <VoiceOverOffIcon />
                                                                                                          {"غیر فعال"}
                                                                                                    </Fab>
                                                                                                ) : (
                                                                                                    <Fab
                                                                                                        variant="extended"
                                                                                                        style={{ background: "#44b700" }}
                                                                                                    >
                                                                                                          <RecordVoiceOverIcon />
                                                                                                          {"فعال"}
                                                                                                    </Fab>
                                                                                                )}
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                                )
                                                                          })}
                                                                </TableBody>
                                                          </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[10, 25, 100]}
                                                        component="div"
                                                        count={agentInfofilter.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onChangePage={this.handleChangePage}
                                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                    />
                                              </Paper>
                                        </Container>
                                  </Grid>
                            </Grid>

                            {okstatus ? (
                                <Alert severity="success">
                                      <AlertTitle>پیام</AlertTitle>
                                      {errstr}
                                </Alert>
                            ) : null}
                            <Dialog
                                open={this.state.openDialog}
                                onClose={this.handleClose}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                  <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه سازندگان ابنیه را حذف نمایید"}</DialogTitle>
                                  <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                              ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                        </DialogContentText>
                                  </DialogContent>
                                  <DialogActions>
                                        <Button onClick={this.handleClose} color="primary">
                                              انصراف
                                        </Button>
                                        <Button onClick={this.deleteABNPrice} color="primary" autoFocus>
                                              بله انجام شود
                                        </Button>
                                  </DialogActions>
                            </Dialog>
                      </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePriceResponseABN)
